import {HelmetProvider} from '@dr.pogodin/react-helmet';
import {i18n} from '@online-offer/i18n';
import {ComponentsProvider} from 'platform/components';
import {LocaleProvider} from 'platform/locale';
import {StyleSheetManager} from 'styled-components';

import {ReactNode} from 'react';
import {Provider} from 'react-redux';

import {GlobalStyles} from '../../GlobalStyles';
import {store} from '../../store';
import {getWorkspaceCustomization} from '../../utils/getWorkspaceCustomization';

interface MainBoundaryProps {
  children: ReactNode;
}

export function MainBoundary(props: MainBoundaryProps) {
  const {theme} = getWorkspaceCustomization();

  return (
    <Provider store={store}>
      <StyleSheetManager enableVendorPrefixes>
        <ComponentsProvider theme={theme} t={i18n.t} language={i18n.language}>
          <HelmetProvider>
            <LocaleProvider language={i18n.resolvedLanguage}>{props.children}</LocaleProvider>
            <GlobalStyles />
          </HelmetProvider>
        </ComponentsProvider>
      </StyleSheetManager>
    </Provider>
  );
}
